import React, { ReactElement } from 'react';
import TableRow from '../table-row/table-row.component';
import TableCell from '../table-cell/table-cell.component';
import useStylesTableRowHelper from './table-row-helper.styles';

const TableRowHelper: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COL_SPAN_DEFAULT: number = 2;

  const {
    colSpan,
  } = props;

  const { classes } = useStylesTableRowHelper();

  return (
    <TableRow className={classes.tableRowHelper}>
      <TableCell colSpan={colSpan || COL_SPAN_DEFAULT} />
    </TableRow>
  );
});

export default TableRowHelper;
